var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { makeObservable, observable, action } from "mobx";
//import {CalendarLink, CalendarNotification} from '@@/Calendar';
export class AddMiscContactStore {
    constructor() {
        this.left = 20;
        this.top = 100;
        this.width = 500;
        this.height = 500;
        this.show = false;
        this.name = "";
        this.email = "";
        this.number = "";
        this.hint = "";
        this.password = "";
        this.adding = false;
        this.dragging = false;
        makeObservable(this);
    }
    setName(name) {
        this.name = name;
    }
    setEmail(email) {
        this.email = email;
    }
    setNumber(number) {
        this.number = number;
    }
    setHint(hint) {
        this.hint = hint;
    }
    setPassword(password) {
        this.password = password;
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(dragging) {
        this.dragging = dragging;
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
    addNewContact() {
    }
    reset() {
        this.setShow(false);
        this.setDragging(false);
        this.setName("");
        this.setEmail("");
        this.setHint("");
        this.setPassword("");
        this.setNumber("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "email", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "number", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "hint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "password", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "adding", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMiscContactStore.prototype, "dragging", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setNumber", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddMiscContactStore.prototype, "reset", null);
